<div class="container col dashboard-container">
  <div class="row h-100">
    <div class="col-md-2 d-none d-md-block dashboard-nav-container sidebar-outer pl-0 pr-0">
      <ul class="fixed pl-0">
        <ng-container *ngFor="let nav of navItems">
          <li [ngClass]="{'active' : getActiveRoute() === nav.route}" (click)="setActiveTab(nav.tab)">
            <a>{{ nav.name }}</a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="card card-primary col-xs-12 col-md-10 no-background card-container">
      <div class="card-body card-container p-0">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>